import * as React from "react";

function SvgIcons8Opera(props, ref) {
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...{ ...props, ref }}>
      <path
        fill="#ff1744"
        d="M24 4C12.947 4 4 12.947 4 24s8.947 20 20 20 20-8.947 20-20S35.053 4 24 4zm0 35c-5.263 0-10-6.896-10-15S18.737 9 24 9s10 6.896 10 15-4.737 15-10 15z"
      />
      <path
        fill="#d50000"
        d="M36.564 8.445C34.413 6.972 31.89 6 29.263 6c-3.948 0-7.524 1.98-10.166 5.079C20.573 9.77 22.255 9 24 9c5.263 0 10 6.896 10 15s-4.737 15-10 15c-1.745 0-3.427-.77-4.903-2.079C21.739 40.02 25.315 42 29.263 42c2.626 0 5.15-.972 7.3-2.444C41.097 35.891 44 30.29 44 24c0-6.289-2.903-11.89-7.436-15.555z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Opera);
